import { ReactNode } from 'react';
import styles from './converter-layout.module.scss';
import { FullscreenHost } from '../fullscreen-host.component';

export interface ConverterLayoutProps {
    // Top toolbar — typically format selectors or "From [▼]  To [▼]".
    toolbar?: ReactNode;

    // Input panel.
    inputLabel: ReactNode;
    inputMeta?: ReactNode;       // small status text aligned with label (right-aligned)
    inputArea: ReactNode;
    inputActions?: ReactNode;    // upload, paste-from-clipboard, etc.

    // Output panel.
    outputLabel: ReactNode;
    outputMeta?: ReactNode;
    outputArea: ReactNode;
    outputActions?: ReactNode;   // copy, download

    // Primary CTA centered below both columns.
    primaryAction?: ReactNode;

    // Optional error/status surface that spans both columns.
    error?: string | null;
}

// Shared symmetric layout for input→action→output tools. All consumers of
// this layout end up structurally identical: input and output panels at the
// same y, textareas equal height, action rows at the same y, primary CTA
// centered below.
export function ConverterLayout(props: ConverterLayoutProps) {
    return (
        <FullscreenHost>
            {props.toolbar && <div className={styles.toolbar}>{props.toolbar}</div>}

            <div className={styles.body}>
                <div className={styles.col}>
                    <div className={styles.colHeader}>
                        <span className={styles.colLabel}>{props.inputLabel}</span>
                        {props.inputMeta && <span className={styles.colMeta}>{props.inputMeta}</span>}
                    </div>
                    {props.inputArea}
                    <div className={styles.actions}>
                        {props.inputActions}
                    </div>
                </div>

                <div className={styles.col}>
                    <div className={styles.colHeader}>
                        <span className={styles.colLabel}>{props.outputLabel}</span>
                        {props.outputMeta && <span className={styles.colMeta}>{props.outputMeta}</span>}
                    </div>
                    {props.outputArea}
                    <div className={`${styles.actions} ${styles.actionsRight}`}>
                        {props.outputActions}
                    </div>
                </div>
            </div>

            {props.error && <div className={styles.errorMessage} role="alert">{props.error}</div>}

            {props.primaryAction && (
                <div className={styles.primary}>{props.primaryAction}</div>
            )}
        </FullscreenHost>
    );
}

export const layoutStyles = styles;
